module.exports = __webpack_public_path__ + "img/box-open-full.14be272a.svg";